import { gql } from "@apollo/client";

export const monthOptions = [
  { label: "January", value: "1" }, 
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" }
];

const currentYear = new Date().getFullYear();

export const yearOptions = Array.from({ length: currentYear - 2000 + 1 }, (_, index) => {
  const year = 2000 + index;
  return { label: year.toString(), value: year.toString() };
});

export const getCheckinCheckoutQuery = gql`
query MonthlyUserwiseAttendance($month: Int!, $year: Int!) {
  monthlyUserwiseAttendanceReport(month: $month, year: $year) {
    empid
    firstName
    lastName
    shift
    totalWorkingHourCount
    presentCount
    absentCount
    attendance {
      date
      checkIn
      checkOut
      totalWorkingHours
      overtime
      status
    }
  }
}`;